import React from 'react';

import { di } from 'react-magnetic-di';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditLocalTimeInput } from './edit';
import { PreviewLocalTimeInput } from './preview';
import { ViewLocalTimeInput } from './view';

export const LocalTimeInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	switch (renderMode) {
		case FormRenderMode.EDIT:
			return (
				<EditLocalTimeInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
		case FormRenderMode.PREVIEW:
			return (
				<PreviewLocalTimeInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
		default:
			return (
				<ViewLocalTimeInput
					fieldId={fieldId}
					fieldInputId={fieldInputId}
					fieldLabelId={fieldLabelId}
					fieldErrorId={fieldErrorId}
				/>
			);
	}
};
